const baseEvent = {
  event: 'loadEventData',
  eventCategory: 'Content',
  nonInteractive: false,
  customMetrics: {},
  customVariables: {},
  _clear: true
}

// Impressions and clicks must share the list name, or the click isn't attributed to the impression
const LIST = 'HotZone'

interface HotZoneProduct {
  id: string
  name?: string
}

const toProduct = ({ id, name }: HotZoneProduct) => ({ id, name, category: LIST, list: LIST })

const zoneEvent = (eventAction: string, eventLabel: string) => ({
  ...baseEvent,
  eventCategory: 'HotZone',
  eventAction,
  eventLabel
})

export default {
  onClick: (eventLabel: string) => zoneEvent('Open HotZone', eventLabel),
  onClose: (eventLabel: string) => zoneEvent('Close HotZone', eventLabel),
  onProductClick: (product: HotZoneProduct) => ({
    ...baseEvent,
    event: 'productClick',
    eventCategory: 'Enhanced Ecommerce',
    eventAction: 'HotZone Click',
    eventLabel: product.id,
    ecommerce: {
      click: {
        actionField: { action: 'HotZone Click', list: LIST },
        products: [toProduct(product)]
      }
    }
  }),
  onProductImpressions: (products: HotZoneProduct[]) => ({
    ...baseEvent,
    event: 'productImpressions',
    eventCategory: 'Enhanced Ecommerce',
    eventAction: 'Product Impressions',
    eventLabel: undefined,
    nonInteractive: true,
    ecommerce: {
      impressions: products.map(toProduct)
    }
  })
}
